module.exports = __webpack_public_path__ + "img/slide6.e52d8dc1.png";